import { combineReducers } from 'redux';
import songsReducer from './songs';

const allReducers = combineReducers({
    songsReducer: songsReducer
})

export default allReducers;